import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MuiIconButton from '@material-ui/core/IconButton';
import RichTextField from 'Components/ComponentLibrary/Molecules/RichTextField';
import SendIcon from '@material-ui/icons/Send';
import ChatIcon from '@material-ui/icons/Chat';
import CloseIcon from '@material-ui/icons/Close';
import Badge from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Badge';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { CircularProgress } from '@material-ui/core';
import { useCommentLayoutContext } from '../../../../CommentLayoutProvider';

const useStyles = buildUseStyles('InputBar', ((theme) => ({
  root: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
  },
  form: {
    width: '100%',
  },
  closeButton: {
    marginRight: theme.spacing(1),
  },
  loader: {
    height: 40,
    width: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
})));

const InputBar = () => {
  const classes = useStyles();
  const {
    showCommentLayout,
    toggleShowComments,
    handleSendMessage,
    sendingMessage,
    threadResource,
    inflightMessage,
  } = useCommentLayoutContext();
  const [text, setText] = React.useState('');
  const IconComponent = (showCommentLayout) ? CloseIcon : ChatIcon;

  return (
    <Box
      className={classes.root}
    >
      <MuiIconButton
        className={classes.closeButton}
        color={'primary'}
        onClick={() => {
          return toggleShowComments();
        }}
      >
        <Badge
          invisible={!threadResource?.isTruthy('isUnread') || showCommentLayout}
          variant={'dot'}
          test="open-comment-thread-button"
        >
          <IconComponent />
        </Badge>
      </MuiIconButton>
      <form
        className={classes.form}
        onSubmit={() => {
          return handleSendMessage(text, setText);
        }}
      >
        <RichTextField
          inputMinHeight={40}
          value={text}
          onChange={(value) => {
            setText(value);
          }}
          inlineToolbar={!inflightMessage ? (
            <IconButton
              className={classes.sendButton}
              disabled={sendingMessage}
              onClick={async () => {
                await handleSendMessage(text, setText);
                return toggleShowComments();
              }}
              variant={'contained'}
              color={'primary'}
              title={'Send Message'}
              icon={SendIcon}
            />) : (
              <Box className={classes.loader}>
                <CircularProgress
                  size={18}
                />
              </Box>)
          }
        />
      </form>
    </Box>
  );
};

export default InputBar;
